// Dates formatted with moment ('LL', 'LLLL', 'MMM D' …) follow moment's global
// locale, which nothing ever set, so every date on the site read "September
// 24, 2026" whatever language the page was in. This sets it once, from the
// locale Rails rendered the page in.
//
// Each locale is imported explicitly: moment ships them as separate modules and
// only English is built in. Importing one also switches moment's global locale
// to it, so applyMomentLocale must run after these imports, including for
// English.
//
// The ESM locale files (moment/dist/locale), not moment/locale: under Vite,
// `import moment from 'moment'` is the ESM build, while moment/locale/* and
// `import 'moment/moment'` are the CommonJS one — a second, separate moment.
// Mixing them registered the locales on one copy (left on Portuguese, the last
// import) and set the page's locale on the other. Import `moment` everywhere,
// never `moment/moment`. (Jest maps these back to the CommonJS files, where
// there is only one copy — see jest.config.js.)
import moment from 'moment'
import 'moment/dist/locale/de'
import 'moment/dist/locale/es'
import 'moment/dist/locale/fr'
import 'moment/dist/locale/ga'
import 'moment/dist/locale/it'
import 'moment/dist/locale/nl'
import 'moment/dist/locale/pt'

const MOMENT_LOCALES = ['de', 'es', 'fr', 'ga', 'it', 'nl', 'pt']

// Our locale code -> moment's. Anything we don't ship a moment locale for,
// en-US included, keeps moment's default English formats.
export function momentLocaleFor (code?: string | null): string {
  const language = (code || '').toLowerCase().split(/[-_]/)[0]
  return MOMENT_LOCALES.includes(language) ? language : 'en'
}

export function applyMomentLocale (code?: string | null): string {
  return moment.locale(momentLocaleFor(code))
}
